import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { BackgroundNewsArticle, CreativeWork } from "schema-dts";

import { useArticleSchemaContext } from "~/components/article/article-schema/contexts";
import type { SwGCompatibleSchema } from "~/components/article/article-schema/types";

type Props = Record<string, never>;

export const BackgroundNewsArticleSchema: FunctionComponent<Props> = () => {
  const { schemaData } = useArticleSchemaContext();

  return schemaData ? (
    <JsonLd<SwGCompatibleSchema<CreativeWork, BackgroundNewsArticle>>
      item={{
        "@context": "https://schema.org",
        "@type": ["CreativeWork", "BackgroundNewsArticle"],
        ...schemaData,
      }}
    />
  ) : null;
};

BackgroundNewsArticleSchema.displayName = "BackgroundNewsArticleSchema";
